/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT 
    http://tympanus.net/Tutorials/CustomFileInputs/
*/

'use strict';

;
(function ($, window, document, undefined) {
  $('.customFileInput').each(function () {
    var $input = $(this),
      $label = $('.customFileInput-label'),
      labelVal = $label.html();
    $input.on('change', function (e) {
      var fileName = '';
      function validFileType(file, accept) {
        var fileExtension = "";
        if (file.name.lastIndexOf(".") > 0) {
          fileExtension = file.name.substring(file.name.lastIndexOf("."), file.name.length);
        }
        for (var i = 0; i < accept.length; i++) {
          if (file.type === accept[i]) {
            return true;
          }
          if (fileExtension === accept[i]) {
            return true;
          }
        }
        return false;
      }
      if ($(this).attr('accept') !== 'media_type') {
        var accept = $(this).attr('accept').split(",");
        $("label[for='" + $(this).attr('id') + "']").siblings('.flexibleEmailFormComponent-validationError.flexibleEmailFormComponent-filetypeError').text("");
        for (var i = 0; i < this.files.length; i++) {
          var file = this.files[i];
          if (accept.length > 0 && !validFileType(file, accept)) {
            $(this).val('');
            $("label[for='" + $(this).attr('id') + "']").siblings('.flexibleEmailFormComponent-validationError.flexibleEmailFormComponent-filetypeError').text($(this).data("invalid-filetype-error-text"));
          }
        }
      }
      if (this.files && this.files.length > 1) {
        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
      } else if (e.target.value) fileName = e.target.value.split('\\').pop();
      if (fileName) $label.html(fileName);else $label.html(labelVal);
    });

    // Firefox bug fix
    $input.on('focus', function () {
      $input.addClass('has-focus');
    }).on('blur', function () {
      $input.removeClass('has-focus');
    });
  });
})(jQuery, window, document);